/**
 * @class
 * @extends P3.Button
 */
export default class MuteMusicButton extends P3.Button {
    /**
     * @param {ButtonStates} states
     */
    constructor(states) {
        super(states);

        !this._states.iconAlt && (this._states.iconAlt = PIXI.Texture.EMPTY);

        this._currentIconTexture = this.isEnabled() ? this._states.icon : this._states.iconAlt;
        this._currentIconOverTexture = this.isEnabled() ? this._states.iconOver : this._states.iconOverAlt;
        this._currentIconDownTexture = this.isEnabled() ? this._states.iconDown : this._states.iconDownAlt;

        this._icon.texture = (this._states.iconOver && !PIXI.utils.isMobile.any) ? this._currentIconOverTexture : this._currentIconTexture;
    }

    /**
     * @param {Event} event
     * @private
     */
    onMouseClick(event) {
        this._currentIconTexture = !this.isEnabled() ? this._states.icon : this._states.iconAlt;
        this._currentIconOverTexture = !this.isEnabled() ? this._states.iconOver : this._states.iconOverAlt;
        this._currentIconDownTexture = !this.isEnabled() ? this._states.iconDown : this._states.iconDownAlt;

        this._icon.texture = (this._states.iconOver && !PIXI.utils.isMobile.any) ? this._currentIconOverTexture : this._currentIconTexture;

        P3.audio.mute(!P3.audio.isMuted("music"), "music");

        super.onMouseClick(event);
    }

    /**
     * @returns {boolean}
     */
    isEnabled() {
        return !P3.audio.isMuted("music");
    }
}